// React Dependencies
import React from 'react';

// External Dependencies
import { Box } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import PropTypes from 'prop-types';

// Internal Dependencies
import ProgressiveImage from '../common/ProgressiveImage';
import convert from '../../common/convert';

// ============================================================
// PHOTO CARD
// ============================================================
//
// This card is used ONLY by Snapstyr Photos.
//
// Clicking the card moves the photo into Pinned Photos.
//
// Renders as a responsive square (via padding-top aspect-ratio
// trick) so 3 cards always fill the row width with a gap.
//
// ============================================================

const PhotoCard = (props) => {
  const { photo, onSelect, photoSize } = props;

  const handleSelect = (event) => {
    event.stopPropagation();
    onSelect(photo);
  };

  return (
    <Box
      position="relative"
      width="100%"
      borderRadius={4}
      overflow="hidden"
      bgcolor="#fff"
      style={{
        cursor:     'pointer',
        transition: 'all 0.15s ease',
      }}
      onClick={handleSelect}
    >
      {/* ====================================================
          SQUARE ASPECT-RATIO WRAPPER
          paddingTop: 100% forces height to equal width
      ===================================================== */}

      <Box
        position="relative"
        width="100%"
        style={{ paddingTop: '100%' }}
        bgcolor="#f5f5f5"
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
        >
          <ProgressiveImage
            image={convert.imageResizeUrl(
              photo.photoUrl,
              photoSize,
              photoSize,
            )}
            style={{
              width:     '100%',
              height:    '100%',
              objectFit: 'cover',
            }}
            draggable={false}
          />

          {/* ==================================================
              ADD (+) BUTTON
              TOP RIGHT — signals the photo can be clicked to pin
          =================================================== */}

          <Box
            position="absolute"
            top={7}
            right={7}
            zIndex={2}
            width={28}
            height={28}
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor="rgba(255,255,255,0.95)"
            borderRadius="50%"
            boxShadow="0 1px 4px rgba(0,0,0,0.25)"
            onClick={handleSelect}
          >
            <Add
              style={{
                fontSize: 18,
                color:    '#1976d2',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

PhotoCard.propTypes = {
  photo: PropTypes.shape({
    photoUrl: PropTypes.string.isRequired,
  }),
  onSelect:  PropTypes.func.isRequired,
  photoSize: PropTypes.number,
};

PhotoCard.defaultProps = {
  photo: {
    photoUrl: 'https://example.com',
  },
  photoSize: 300,
};

export default PhotoCard;
